module.exports = __webpack_public_path__ + "img/github.da2c682a.svg";